<ui-suggest [items]="choices"
            [clearable]="!required"
            [defaultValue]="currentValue"
            (selected)="onChoiceSelect($event)"
            [required]="required">
</ui-suggest>
